<template>
    <div>
        <loading-indicator :clearBackground="true" :fullParent="false" :isLoading="isLoading" />
        <div v-if="paging && sortedCustomerBookingPasses.length > 0">
            <div class="text-right paging-information d-flex justify-content-end align-items-center">
                <span>
                    {{$t('paging_information_entry', this.paging)}}
                </span>
                <span v-if="this.paging.last_page > 0">
                    &nbsp;{{$t('paging_information_page', this.paging)}}
                </span>
            </div>
            <pagination :paging="paging" :is-loading="isLoading" @pageClick="(page) => {this.loadPage(page)}"/>
        </div>
        <table v-if="sortedCustomerBookingPasses.length" class="w-100 ding-table" border=0>
            <thead>
                <th></th>
                <th>{{$t('title')}}</th>
                <!-- <th>{{$t('redeem_count_left')}}</th> -->
                <!-- <th>{{$t('expiration_date')}}</th> -->
            </thead>
            <tbody>
                <tr
                    v-for="customerBookingPass in sortedCustomerBookingPasses"
                    :key="customerBookingPass.id" class="rounded-0"
                    :class="{'bg-white': customerId}"
                    @click="openedCustomerBookingPass = customerBookingPass">
                    <td width="170">
                        <img
                            v-if="customerBookingPass?.booking_pass?.image?.file_name"
                            :src="context.storageEndpoint + customerBookingPass.booking_pass.image.file_name" style="max-width: 125px;"
                        />
                    </td>
                    <td>{{ customerBookingPass.booking_pass?.title }}</td>
                    <!-- <td class="blue-highlight">
                        <div>{{ customerBookingPass.redeem_count_left }}</div>
                    </td> -->
                    <!-- <td>
                        <div v-if="isExpired(customerBookingPass)">{{ $t('expired') }}</div>
                        <div v-if="customerBookingPass.expire_at">
                            <span>{{ $t('general.to') }}</span>
                            <span>{{ formatDate(customerBookingPass.expire_at) }}</span>
                        </div>
                        <div v-else>{{ $t('no_expired_date') }}</div>
                    </td> -->
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center text-muted pt-4">
            <small>{{ $t('no_customer_booking_passes') }}</small>
        </div>

        <customer-booking-pass-viewer
            v-if="openedCustomerBookingPass?.booking_pass"
            :context="context"
            :provider="provider"
            :customer-booking-pass="openedCustomerBookingPass"
            :pass="openedCustomerBookingPass?.booking_pass"
            :customer-id="customerId"
            @close="openedCustomerBookingPass = null"
        />
    </div>
</template>

<script>
import api from '../../mixins/api';
import promptConfirm from '../../mixins/prompt-confirm';
import moment from 'moment';
import 'moment-timezone';
import loadingIndicator from '../../components/common/LoadingIndicator';
import Pagination from '../common/Pagination.vue';
import CustomerBookingPassViewer from '../CustomerBookingPassViewer.vue';

export default {
    props: {
        provider: { type: Object, required: true },
        context: { type: Object, required: true },
        customerId: { required: false }, // 如果是廠商後台看的話，會直接指名 customerId
    },
    components: { loadingIndicator, Pagination, CustomerBookingPassViewer },
    mixins: [api, promptConfirm],
    mounted() {
        this.loadPage(1);
    },
    data() {
        return {
            isLoading: false,
            customerBookingPasses: [],
            paging: null,
            openedCustomerBookingPass: null,
        }
    },
    computed: {
        sortedCustomerBookingPasses() {
            return this.customerBookingPasses.sort((a, b) => {
                a.isExpired = this.isExpired(a);
                b.isExpired = this.isExpired(b);

                if (a.isExpired && !b.isExpired) {
                    return 1;
                } else if (!a.isExpired && b.isExpired) {
                    return -1;
                }

                return b.id - a.id;
            })
        }
    },
    methods: {
        isExpired(customerBookingPass) {
            if (customerBookingPass.expire_at) {
                const now = moment();
                const expireAt = moment.tz(customerBookingPass.expire_at, 'GMT');
                return now.isAfter(expireAt);
            } else {
                return false;
            }
        },
        formatDate(date) {
            return moment.tz(date, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD');
        },
        loadPage(page) {
            this.isLoading = true;
            const callback = (response, error) => {
                this.isLoading = false;
                if (error) {
                    this.promptAlert(error);
                } else {
                    this.customerBookingPasses = response.data.data;
                    this.paging = response.data;
                }
            };
            if (this.customerId) {
                this.getCustomerBookingPassesByAdmin(this.customerId, page, callback);
            } else {
                this.getCustomerBookingPasses(page, callback);
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .ding-table {
        table-layout: auto;

        th {
            white-space: nowrap;
        }

        tr {
            cursor: pointer;
            background-color: #F6F6F6;
        }
    }

    .blue-highlight {
        color: #0094FB;
    }

    .paging-information {
        font-size: 12px;
        margin: 16px 0px;
        color: #90A4AE;
    }

    td:has(> .img-container) {
        max-width: 100px;
    }

    .img-container {
        width: 100%;

        img {
            width: 100%;
        }
    }

</style>

<i18n>
{
    "en": {
        "no_customer_booking_passes": "No booking passes",
        "no_expired_date": "Permanent",
        "cover": "Cover",
        "title": "Title",
        "expiration_date": "Expired Date",
        "redeem_count_left": "Redeem Count Left",
        "expired": "Expired",
        "paging_information_entry": "Total {total} booking passes",
        "paging_information_page": "({current_page} / {last_page} pages)"
    },
    "zh": {
        "no_customer_booking_passes": "目前沒有任何課卡",
        "no_expired_date": "永久有效",
        "cover": "封面",
        "title": "標題",
        "expiration_date": "有效期限",
        "redeem_count_left": "剩餘預約次數",
        "expired": "已過期",
        "paging_information_entry": "共 {total} 張",
        "paging_information_page": " ({current_page}/{last_page} 頁)"
    }
}
</i18n>